import React from 'react';
import PropTypes from 'prop-types';

import styles from './Styles.module.css';

class FeaturedIn extends React.PureComponent {
  static propTypes = {
    customClass: PropTypes.string,
  };

  static defaultProps = {
    customClass: null,
  };

  getStyle = (size, height) => {
    return {
      fontSize: `${size}em`,
      lineHeight: `${height}px`,
    };
  };

  render() {
    const { customClass } = this.props;
    return (
      <div
        className={`${styles['home-featured-container']} ${
          customClass && styles[customClass] ? styles[customClass] : ''
        }`}
      >
        <div className={styles['featured-label']}>Featured In</div>
        <div className={styles['featured-labels-list']}>
          <div className="icon-nyt" alt="The New York Times" style={this.getStyle(3, 40)} />
          <div className="icon-marketwatch" alt="MarketWatch" style={this.getStyle(7.3, 53)} />
          <div className="icon-forbes" alt="Forbes" style={this.getStyle(4.2, 50)} />
          <div
            className="icon-bi hide-logo-on-mobile"
            alt="Business Insider"
            style={this.getStyle(4.5, 50)}
          />
          <div className="icon-nbc hide-logo-on-mobile" alt="NBC" style={this.getStyle(2.2, 40)} />
          <div
            className="icon-msn hide-logo-on-mobile"
            alt="MSN"
            style={this.getStyle(4.187, 40)}
          />
          <div
            className="icon-fortune hide-logo-on-mobile"
            alt="Fortune"
            style={this.getStyle(4.75, 45)}
          />
          <div
            className="icon-yahoo hide-logo-on-tablet hide-logo-on-mobile"
            alt="Yahoo"
            style={this.getStyle(5.812, 45)}
          />
        </div>
      </div>
    );
  }
}
export default FeaturedIn;
